<section class="testimonials-section">
  <div class="container">
    <app-section-title title="Reviews" alignment="center" theme="dark">
    </app-section-title>

    <div class="scroll-wrapper" (mouseenter)="pauseAutoScroll()" (mouseleave)="resumeAutoScroll()">
      <!-- Left Control -->
      <app-carousel-controls (prev)="scroll('left')" [showNext]="false" [canGoPrev]="true">
      </app-carousel-controls>

      <div class="cards-container" #scrollContainer>
        <div class="card-item" *ngFor="let item of testimonials">
          <app-testimonial-card [testimonial]="item"></app-testimonial-card>
        </div>
      </div>

      <!-- Right Control -->
      <app-carousel-controls (next)="scroll('right')" [showPrev]="false" [canGoNext]="true">
      </app-carousel-controls>
    </div>
  </div>
</section>
